import React from "react";
import "./App.css";
import notification from "antd/es/notification";
import Spin from "antd/es/spin";
import Video from "twilio-video";
import ClearCache from "react-clear-cache";
import Room from "./Room";
import BlankCache from "./BlankCache";
import Queue from "./components/Queue";
import helper from "./utils/helper";
import FormAuth from "./components/FormAuth";
import Emitter from "./utils/emitter";
import http from "./utils/http";

function VideoCall(props) {
  const [room, setRoom] = React.useState(null);
  const [queue, setQueue] = React.useState({ inQueue: 0, queuePosition: 0 });
  const [loading, setLoading] = React.useState(false);
  const [waiting, setWaiting] = React.useState(false);
  const [audioStatus, setAudioStatus] = React.useState(true);
  const [videoStatus, setVideoStatus] = React.useState(true);
  const [response, setResponse] = React.useState(null);

  React.useEffect(() => {
    const sid = new URLSearchParams(window.location.search).get("sid");
    const type = new URLSearchParams(window.location.search).get("type");

    if (type === "sharing") {
      if (sid) {
        setLoading(true);
        http
          .get(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/sharing/${sid}?timestamp=${new Date().getMilliseconds()}`
          )
          .then((res) => {
            setLoading(false);
            onConnectSharing(sid, res.data.token);
          })
          .catch(() => {
            setLoading(false);
            let qp = new URLSearchParams();
            qp.set("sid", "");
            qp.set("type", "");
            window.history.replaceState(null, null, "?" + qp.toString());
          });
      }
    } else {
      if (localStorage.getItem("sid") || sid) {
        setLoading(true);
        if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
          http.post(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/updateLocation?timestamp=${new Date().getMilliseconds()}`,
            {
              sid: sid ? sid : localStorage.getItem("sid"),
              location: {
                latitude: props.lat,
                longitude: props.long,
              },
            }
          );
        }
        http
          .get(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/sessionStatus/${
              sid ? sid : localStorage.getItem("sid")
            }?timestamp=${new Date().getMilliseconds()}`
          )
          .then((res) => {
            http
              .get(
                `${process.env.REACT_APP_API_URL}/${
                  process.env.REACT_APP_TENANT
                }/session/${
                  sid ? sid : localStorage.getItem("sid")
                }?timestamp=${new Date().getMilliseconds()}`
              )
              .then((resp) => {
                setLoading(false);
                resp.data.status = res.data;
                setResponse(resp.data);
                if (res.data === "waiting" || res.data === "initiated") {
                  onWait(
                    resp.data.token,
                    resp.data.room.uniqueName,
                    resp.data.body.email
                  );
                } else {
                  onConnect(
                    resp.data.token,
                    resp.data.room.uniqueName,
                    resp.data.body.email
                  );
                }
              })
              .catch(() => {
                setLoading(false);
                let qp = new URLSearchParams();
                qp.set("sid", "");
                window.history.replaceState(null, null, "?" + qp.toString());
                localStorage.removeItem("sid");
              });
          })
          .catch(() => {
            setLoading(false);
            let qp = new URLSearchParams();
            qp.set("sid", "");
            window.history.replaceState(null, null, "?" + qp.toString());
            localStorage.removeItem("sid");
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (response) {
      const parameterVidcall = JSON.stringify({
        tenant_id: process.env.REACT_APP_TENANT,
        userid: response?.body?.email,
        type: "customer",
        room: response?.room?.uniqueName,
      });

      const paramsVidcall = helper.encrypt(parameterVidcall);

      let socketVidcall = window.io(process.env.REACT_APP_API_URL, {
        path: `/${process.env.REACT_APP_TENANT}/socket.io`,
        query: { data: paramsVidcall },
        transports: ["websocket"],
      });

      if (response?.status !== "handling") {
        checkQueue(response?.room?.uniqueName);
      }

      const intervalTime = parseInt(process.env.REACT_APP_INTERVAL)

      const intervalQueue = setInterval(() => {
        if (response?.status !== "handling") {
          checkQueue(response?.room?.uniqueName);
        } else {
          clearInterval(intervalQueue);
        }
      }, intervalTime);

      socketVidcall.on("accept_video_call", (data) => {
        setLoading(false);
        clearInterval(intervalQueue);
        onConnect(
          response?.token,
          response?.room?.uniqueName,
          response?.body?.email
        );
      });

      socketVidcall.on("end_video_call", (data) => {
        localStorage.removeItem("sid");
        handleLogout();
      });

      socketVidcall.on("newChatVideoCall", (data) => {
        Emitter.emit("MESSAGE_SET", JSON.parse(helper.decrypt(data)));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const onConnectSharing = (sid, token) => {
    const name = localStorage.getItem("name")
      ? localStorage.getItem("name")
      : helper.makeid(6);
    const email = name + "@gmail.com";
    localStorage.setItem("name", name);
    const parameterVidcall = JSON.stringify({
      tenant_id: process.env.REACT_APP_TENANT,
      userid: email,
      type: "customer",
      room: sid,
    });

    const paramsVidcall = helper.encrypt(parameterVidcall);

    let socketVidcall = window.io(process.env.REACT_APP_API_URL, {
      path: `/${process.env.REACT_APP_TENANT}/socket.io`,
      query: { data: paramsVidcall },
      transports: ["websocket"],
    });

    socketVidcall.on("accept_video_call", (data) => {
      setLoading(false);
      onConnect(token, sid, email);
    });

    socketVidcall.on("end_video_call", (data) => {
      localStorage.removeItem("sid");
      handleLogout();
    });

    socketVidcall.on("newChatVideoCall", (data) => {
      Emitter.emit("MESSAGE_SET", JSON.parse(helper.decrypt(data)));
    });
    onConnect(token, sid, "");
  };
  const onConnect = async (token, name, email) => {
    const videoTrack = await Video.createLocalVideoTrack();
    const audioTrack = await Video.createLocalAudioTrack();
    setLoading(true);
    Video.connect(token, {
      name: name,
      // tracks: [videoTrack, audioTrack],
      // insights: false,
      tracks: [videoTrack, audioTrack],
      insights: false,
      video: {
        frameRate: 24,
      },
      maxAudioBitrate: 16000,
      networkQuality: { local: 1, remote: 1 },
    })
      .then((room) => {
        setRoom(room);
        setWaiting(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        let qp = new URLSearchParams();
        qp.set("sid", "");
        window.history.replaceState(null, null, "?" + qp.toString());
        localStorage.removeItem("sid");
        notification.error({
          message: "Video call tidak dapat tersambung, coba lagi nanti.",
          placement: "bottomRight",
          duration: 5,
        });
      });
  };

  const onWait = async (token, name, email) => {
    setWaiting(true);
  };

  const checkQueue = (sid) => {
    http
      .get(
        `${process.env.REACT_APP_API_URL}/${
          process.env.REACT_APP_TENANT
        }/queuePosition/${sid}?timestamp=${new Date().getMilliseconds()}`
      )
      .then((res) => {
                setQueue(res.data);
      });
  };

  const handleLogout = React.useCallback(() => {
    setRoom((prevRoom) => {
      if (prevRoom) {
        prevRoom.localParticipant.tracks.forEach((trackPub) => {
          trackPub.track.stop();
        });
        prevRoom.disconnect();
      }
      localStorage.removeItem("sid");
      window.location.href = process.env.REACT_APP_REDIRECT_URL;
      return null;
    });
  }, []);

  React.useEffect(() => {
    if (room) {
      const tidyUp = (event) => {
        if (event.persisted) {
          return;
        }
        if (room) {
          handleLogout();
        }
      };
      window.addEventListener("pagehide", tidyUp);
      window.addEventListener("beforeunload", tidyUp);
      return () => {
        window.removeEventListener("pagehide", tidyUp);
        window.removeEventListener("beforeunload", tidyUp);
      };
    }
  }, [room, handleLogout]);

  const handleAudio = () => {
    room.localParticipant.audioTracks.forEach((publication) => {
      if (audioStatus) {
        publication.track.enable(false);
      } else {
        publication.track.enable(true);
      }
    });
    setAudioStatus(!audioStatus);
  };

  const handleVideo = (status) => {
    setVideoStatus(status);
    room.localParticipant.videoTracks.forEach((publication) => {
      if (!status) {
        publication.track.enable(false);
      } else {
        publication.track.enable(true);
      }
    });
  };

  return (
    <Spin spinning={loading} tip="Sedang memproses..." className="h-full">
      {waiting ? (
        <Queue
          setWaiting={setWaiting}
          queue={queue}
          handleLogout={handleLogout}
          response={response}
        />
      ) : room ? (
        <Room
          response={response}
          room={room}
          handleLogout={handleLogout}
          audioStatus={audioStatus}
          handleAudio={handleAudio}
          videoStatus={videoStatus}
          handleVideo={handleVideo}
        />
      ) : (
        <FormAuth
          {...props}
          setLoading={setLoading}
          setResponse={setResponse}
          onWait={onWait}
        />
      )}
    </Spin>
  );
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error_name: "",
      error_description: "",
      error_line: "",
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error_name: error.message,
      error_description: errorInfo.componentStack,
      error_line: errorInfo.componentStack.split(":")[0],
    });
  }

  render() {
    return (
      <ClearCache>
        {({ isLatestVersion, emptyCacheStorage }) =>
          !isLatestVersion ? (
            <BlankCache emptyCacheStorage={emptyCacheStorage} />
          ) : (
            <VideoCall {...this.props} />
          )
        }
      </ClearCache>
    );
  }
}

export default App;
